

























































import { getRange } from '@/libs/time';
import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import MyDoneServices from '@/services/mydone';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
@Component
export default class Todo extends mixins(DictMixin, PageMixin) {
  doneSrv = new MyDoneServices();

  created() {
    this.getAll();
  }

  count: any = {};
  async getAll() {
    this.loading = true;
    let [startTime, endTime] = this.date;
    this.count = await this.doneSrv.getApproveCount({ startTime, endTime });
    this.params = { startTime, endTime };
    await this.getList();
    this.loading = false;
  }

  params: any = {};

  async getList() {
    let res = await this.doneSrv.getApprovePage({ ...this.params, page: this.page, limit: this.limit });
    this.dataSource = res.records;
    this.total = res.total;
  }

  async getDueTableList(params?: any) {
    let res = await this.doneSrv.getApprovePage({ ...params, page: this.page, limit: this.limit });
    let records = res.records.filter((rec: any) => rec.appDate > rec.appDueDate);
    this.dataSource = records;
    this.total = res.total;
  }

  async getCurrentList(type: number) {
    this.page = 1;
    this.loading = true;
    let [startTime, endTime] = this.date;
    this.count = await this.doneSrv.getApproveCount({ startTime, endTime });
    if (type === 0) {
      this.getDueTableList({ startTime: startTime, endTime: endTime, dueFlag: true });
    } else {
      this.params = { endTime, appDate_eq: endTime };
      this.getList();
    }
    this.loading = false;
  }

  date: any = getRange('week');
  @Watch('date')
  onDateChange() {
    this.getAll();
  }

  columns = [
    { title: '任务编号', dataIndex: 'appTaskCode' },
    { title: '任务类别', dataIndex: 'appTaskKind' },
    { title: '任务内容', dataIndex: 'appTaskComment' },
    { title: '申请日期', dataIndex: 'requestDate' },
    { title: '审批期限', dataIndex: 'appDueDate' },
    { title: '审批状态', dataIndex: 'appStatus', customRender: (text: string) => this.DICT_VALUE('DICT_APPROVE_STATUS', text) },
    {
      title: '操作',
      dataIndex: 'action',
      width: 180,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSource = [];
}
